// apps/merchant-v3/src/lib/cn.ts
//
// Phase 6 Wave 1 Task 02 — Tailwind class-name helper. Combines clsx +
// tailwind-merge so component variants can compose without duplicate /
// conflicting utility classes (canonical Shadcn/ui pattern).
//
// vg-binding: PLAN:task-02

import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
